import { render, staticRenderFns } from "./EventTask.vue?vue&type=template&id=a1455350"
import script from "./EventTask.vue?vue&type=script&lang=js"
export * from "./EventTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports